var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extraInfo"},[_c('p',[_vm._v("创建人："+_vm._s(_vm.creator))]),_c('p',[_vm._v("修改人："+_vm._s(_vm.modifier))]),_c('p',[_vm._v("更新时间："+_vm._s(_vm.updateTime))]),_c('p',[_vm._v("收录时间："+_vm._s(_vm.createTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }